/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {emptyRouteView} from '../common/directives/html/route-view-components';
import {LineItemReviewApiService} from './line-item-review-api.service';
import {AxReviewListPageComponent} from './ax-review-list-page.component';

export function axReviewStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
let rh = adnRouterHelper.createRouterHelper('ax-reviews.ax-review', LineItemReviewApiService, 'app.adv', 'app');
    
        states.add(rh.listPath(), rh.list({
          views: {
            'content@app': {component: AxReviewListPageComponent},
            'context@app': emptyRouteView()
          }
        }, "LineItemReview", [{type: 'Advertiser', func: 'isNotSelfService'}, {type: 'Order', func: 'isNotSelfService'}]));
  return states.build();
}
